import { render, staticRenderFns } from "./VehiculosCompartidos.vue?vue&type=template&id=25df68ae&scoped=true&"
import script from "./VehiculosCompartidos.vue?vue&type=script&lang=ts&"
export * from "./VehiculosCompartidos.vue?vue&type=script&lang=ts&"
import style0 from "./VehiculosCompartidos.vue?vue&type=style&index=0&id=25df68ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df68ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25df68ae', component.options)
    } else {
      api.reload('25df68ae', component.options)
    }
    module.hot.accept("./VehiculosCompartidos.vue?vue&type=template&id=25df68ae&scoped=true&", function () {
      api.rerender('25df68ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/VehiculosCompartidos.vue"
export default component.exports